import React from 'react';
import { FileTextIcon, UsersIcon, StarIcon, HeartIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-white border-b border-gray-200 py-12 px-4" data-id="element-251">
      <div className="max-w-7xl mx-auto" data-id="element-252">
        {/* Top Banner */}
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-8 flex items-center justify-center gap-3" data-id="element-253">
          <div className="flex -space-x-2" data-id="element-254">
            <div className="w-10 h-10 rounded-full bg-blue-500 border-2 border-white" data-id="element-255"></div>
            <div className="w-10 h-10 rounded-full bg-green-500 border-2 border-white" data-id="element-256"></div>
            <div className="w-10 h-10 rounded-full bg-orange-500 border-2 border-white" data-id="element-257"></div>
            <div className="w-10 h-10 rounded-full bg-purple-500 border-2 border-white" data-id="element-258"></div>
          </div>
          <p className="text-gray-700 font-semibold" data-id="element-259">
            Già scelto da{' '}
            <span className="text-green-600 font-bold" data-id="element-260">2.847+</span> insegnanti
            in tutta Italia
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-261">
          <div className="bg-blue-50 border border-blue-100 rounded-lg p-6 text-center" data-id="element-262">
            <FileTextIcon className="w-12 h-12 text-blue-600 mx-auto mb-3" data-id="element-263" />
            <div className="text-3xl font-bold text-blue-900 mb-1" data-id="element-264">300+</div>
            <div className="text-gray-700" data-id="element-265">Risorse digitali</div>
          </div>

          <div className="bg-orange-50 border border-orange-100 rounded-lg p-6 text-center" data-id="element-266">
            <UsersIcon className="w-12 h-12 text-orange-600 mx-auto mb-3" data-id="element-267" />
            <div className="text-3xl font-bold text-orange-900 mb-1" data-id="element-268">2.8k+</div>
            <div className="text-gray-700" data-id="element-269">Insegnanti attivi</div>
          </div>

          <div className="bg-green-50 border border-green-100 rounded-lg p-6 text-center" data-id="element-270">
            <StarIcon className="w-12 h-12 text-green-600 mx-auto mb-3 fill-current" data-id="element-271" />
            <div className="text-3xl font-bold text-green-900 mb-1" data-id="element-272">4.9/5</div>
            <div className="text-gray-700" data-id="element-273">Valutazione media</div>
          </div>

          <div className="bg-red-50 border border-red-100 rounded-lg p-6 text-center" data-id="element-274">
            <HeartIcon className="w-12 h-12 text-red-600 mx-auto mb-3 fill-current" data-id="element-275" />
            <div className="text-3xl font-bold text-red-900 mb-1" data-id="element-276">100%</div>
            <div className="text-gray-700" data-id="element-277">Soddisfazione</div>
          </div>
        </div>
      </div>
    </section>;
}